app.factory('dataService', function ($sce) {

    return {
        modifyOptionVal: function(maxResult, weightUnit, minFrontSpace, midleSpace, minEndSpace) {
            return $sce.trustAsHtml(
                this.getOptionData(100, 1, maxResult, weightUnit, 0, minFrontSpace, midleSpace, minEndSpace+1) +
                this.getOptionData(95, 2, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace+1) +
                this.getOptionData(90, 4, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace+1) +
                this.getOptionData(85, 6, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace+1) +
                this.getOptionData(80, 8, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace+1) +
                this.getOptionData(70, 10, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace) +
                this.getOptionData(65, 12, maxResult, weightUnit, 2, minFrontSpace, midleSpace, minEndSpace)
            );
        },
        getOptionData: function(percentage, repeat, maxResult, weightUnit, nbspFirst, minFrontSpace, midleSpace, nbspLast) {
            return "<option>" + this.addNbsp(minFrontSpace) + percentage + "%" + this.addNbsp(nbspFirst)+this.roundResultsV2((maxResult*percentage)/100, midleSpace) + '&nbsp;' + weightUnit + this.addNbsp(nbspLast) + " "+ repeat + "</option>";
        },
        roundResultsV2: function(value, midleSpace) {
            var decimal = value - Math.floor(value);
            var result = decimal ? value.toFixed(1) : value;
            if (String(result).length == 5) {
                return this.addNbsp(2 + midleSpace)+result;
            } else if (String(result).length == 4) {
                return this.addNbsp(4 + midleSpace)+result;
            } else if (String(result).length == 3) {
                return this.addNbsp(6 + midleSpace)+result;
            } else if (String(result).length == 2) {
                return this.addNbsp(7 + midleSpace)+result;
            } else if (String(result).length == 1) {
                return this.addNbsp(9 + midleSpace)+result;
            } else {
                return result;
            }
        },
        addNbsp: function(total) {
            var nbspStr = '';
            for (var i=0; i<total; i++) {
                nbspStr = nbspStr + '&nbsp;';
            }
            return nbspStr;
        }
    };
});
